import {Em2EnquiryTypeMappingDTOEventTypeEnum, Em2EnquiryVehicle, EventType} from "../../../../../../api/generated";
import {SelectOption} from "../../../../../elements/select/SelectDropdown";

export interface Em2EnquiryType {
    id: number;
    name: string;
}

export const em2EnquiryTypes: Em2EnquiryType[] = [
    {id: 1, name: "Auto Used Vehicle Search"},
    {id: 2, name: "Auto Website Exit"},
    {id: 3, name: "Auto New Vehicle WhatCar Review"},
    {id: 4, name: "New Vehicle Brochure Request Enquiry"},
    {id: 5, name: "Auto Used Vehicle PDF Print/Download"},
    {id: 6, name: "Auto Used Vehicle Save to Favourites"},
    {id: 7, name: "Auto Used Vehicle Send to Friend"},
    {id: 8, name: "Auto Used Vehicle WhatCar Review"},
    {id: 9, name: "Directions Print/Request"},
    {id: 10, name: "Auto New Vehicle Finance Calculator"},
    {id: 11, name: "Auto Used Vehicle Finance Calculator"},
    {id: 12, name: "Auto LiveChat"},
    {id: 13, name: "Recruitment Vacancy Application"},
    {id: 14, name: "Auto Stock Update"},
    {id: 15, name: "Auto SMS Subscription"},
    {id: 16, name: "Auto Newsletter Subscription"},
    {id: 17, name: "Auto Recruitment Alerts"},
    {id: 18, name: "Service Enquiry"},
    {id: 19, name: "MOT Enquiry"},
    {id: 20, name: "Parts & Accessories Enquiry"},
    {id: 21, name: "Service Plan Enquiry"},
    {id: 22, name: "Service & MOT Enquiry"},
    {id: 23, name: "Finance Enquiry"},
    {id: 24, name: "Lease Vehicle Enquiry"},
    {id: 25, name: "New Vehicle Email Quote"},
    {id: 26, name: "New Vehicle General Enquiry"},
    {id: 27, name: "New Vehicle Part Exchange Enquiry"},
    {id: 28, name: "New Vehicle Configurator Enquiry (Widget)"},
    {id: 29, name: "Used Vehicle General Enquiry"},
    {id: 30, name: "Used Vehicle Test Drive Enquiry"},
    {id: 31, name: "Used Vehicle Part Exchange Enquiry"},
    {id: 32, name: "Motability Vehicle Enquiry"},
    {id: 33, name: "New Vehicle Offer Enquiry"},
    {id: 34, name: "Used Vehicle Offer Enquiry"},
    {id: 35, name: "Business Offer Enquiry"},
    {id: 36, name: "Aftersales Offer Enquiry"},
    {id: 37, name: "New Vehicle Valuation Enquiry"},
    {id: 38, name: "Used Vehicle Valuation Enquiry"},
    {id: 39, name: "Vehicle Valuation Enquiry"},
    {id: 40, name: "General Enquiry"},
    {id: 41, name: "Directions Enquiry"},
    {id: 42, name: "Auto New Vehicle Share"},
    {id: 43, name: "New Vehicle Test Drive Enquiry"},
    {id: 44, name: "Event Booking"},
    {id: 45, name: "Auto Member Signup"},
    {id: 46, name: "Auto Member Login"},
    {id: 47, name: "Service Booking Matrix Enquiry"},
    {id: 48, name: "Used Vehicle Stock Enquiry"},
    {id: 49, name: "Used Vehicle Negotiation Enquiry"},
    {id: 50, name: "Auto Quick Search"},
    {id: 51, name: "Make An Offer"},
    {id: 52, name: "Service Booking Enquiry"},
    {id: 53, name: "Mobile Content Share"},
    {id: 54, name: "Mobile Stock Share"},
    {id: 55, name: "Mobile Used Stock Enquiry"},
    {id: 56, name: "Callback Request"},
    {id: 57, name: "Auto Used Payment Search"},
    {id: 58, name: "Lease Vehicle Valuation Enquiry"},
    {id: 59, name: "Auto Lease Vehicle Share"},
    {id: 60, name: "General Business Enquiry"},
    {id: 61, name: "Mobile New Vehicle Enquiry"},
    {id: 62, name: "General Business Enquiry (A)"},
    {id: 63, name: "Mobile Directions Request"},
    {id: 64, name: "Offer Enquiry"},
    {id: 65, name: "Mobile Call Us Button"},
    {id: 66, name: "Auto Newsletter Subscription"},
    {id: 67, name: "New Commercial Enquiry"},
    {id: 68, name: "Service Booking (Widget)"},
    {id: 69, name: "Service Plan (Widget)"},
    {id: 70, name: "Tyre Booking (Widget)"},
    {id: 71, name: "Parts & Accessories Product Enquiry"},
    {id: 72, name: "Used Vehicle Online Deposit (Widget)"},
    {id: 73, name: "Mobile New Vehicle Test Drive"},
    {id: 74, name: "Mobile New Vehicle Brochure Request"},
    {id: 75, name: "Auto New Vehicle WhatCar Video"},
    {id: 76, name: "Auto Used Vehicle WhatCar Video"},
    {id: 77, name: "Aftersales Accident Repair Enquiry"},
    {id: 78, name: "Feedback Enquiry"},
    {id: 79, name: "Business Finance Enquiry"},
    {id: 80, name: "Electric Vehicle General Enquiry"},
    {id: 81, name: "Electric Vehicle Test Drive Enquiry"},
    {id: 82, name: "Motability General Enquiry"},
    {id: 83, name: "Motability Brochure Request Enquiry"},
    {id: 84, name: "Motability Test Drive Enquiry"},
    {id: 85, name: "Insurance Enquiry"},
    {id: 86, name: "Roadside Assistance Enquiry"},
    {id: 87, name: "Warranty Enquiry"},
    {id: 88, name: "Loyalty Enquiry"},
    {id: 89, name: "Lease Vehicle Brochure Request Enquiry"},
    {id: 90, name: "Lease Vehicle Test Drive Enquiry"},
    {id: 91, name: "New Commercial Brochure Request Enquiry"},
    {id: 92, name: "New Commercial Test Drive Enquiry"},
    {id: 93, name: "Reserve Vehicle Request"},
    {id: 94, name: "Purchase Vehicle Request"},
    {id: 95, name: "Parts & Accessories Transaction"},
    {id: 96, name: "Vehicle Valuation (Widget)"},
    {id: 97, name: "Used Commercial Enquiry"},
    {id: 98, name: "Used Commercial Test Drive Enquiry"},
    {id: 99, name: "Used Commercial Valuation Enquiry"},
    {id: 100, name: "Used Commercial Negotiation Enquiry"},
    {id: 101, name: "Used Commercial Offer Enquiry"},
    {id: 102, name: "Used Vehicle Video Tour Request"},
    {id: 103, name: "Used Bike Video Tour Request"},
    {id: 104, name: "Used Car Video Tour Request"},
    {id: 105, name: "Used Van Video Tour Request"},
    {id: 106, name: "Used Electric Vehicle Video Tour Request"},
    {id: 107, name: "Used Commercial Video Tour Request"},
    {id: 108, name: "New Vehicle Video Tour Request"},
    {id: 109, name: "New Bike Video Tour Request"},
    {id: 110, name: "New Car Video Tour Request"},
    {id: 111, name: "New Van Video Tour Request"},
    {id: 112, name: "New Electric Vehicle Video Tour Request"},
    {id: 113, name: "New Commercial Video Tour Request"},
    {id: 114, name: "New Vehicle Offer Search"},
    {id: 115, name: "New Vehicle Save And Compare"},
    {id: 116, name: "New Vehicle PDF Print/Download"},
    {id: 117, name: "New Vehicle Search"},
    {id: 118, name: "Sales Offer Update"},
    {id: 119, name: "New Vehicle Launch Enquiry"},
    {id: 120, name: "New Vehicle Brochure Download Enquiry"},
    {id: 121, name: "Lease Vehicle Brochure Download Enquiry"},
    {id: 122, name: "Motability Vehicle Brochure Download Enquiry"},
    {id: 123, name: "New Commercial Brochure Download Enquiry"},
    {id: 124, name: "Used Vehicle Details Page View"},
    {id: 125, name: "Offer Details Page View"},
    {id: 126, name: "RSS Subscription"},
    {id: 127, name: "Offer Search"},
    {id: 128, name: "Save And Compare"},
    {id: 129, name: "Compare Vehicles"},
    {id: 130, name: "Used Vehicle Listing Change View"},
    {id: 131, name: "Video View"},
    {id: 132, name: "Vehicle Like"},
    {id: 133, name: "Vehicle Link"},
    {id: 134, name: "Customer Interests Enquiry"},
    {id: 138, name: "Accessories Enquiry"},
    {id: 139, name: "Parts Enquiry"},
    {id: 140, name: "HPI Seller Check Enquiry"},
    {id: 141, name: "Personal Shopper Enquiry"},
    {id: 146, name: "Service Enquiry (Customer Options)"},
    {id: 148, name: "Customer Complaint Enquiry"},
    {id: 149, name: "Used Vehicle Image Request Enquiry"},
    {id: 150, name: "JLR Test Drive Booking (Widget)"},
    {id: 151, name: "JLR Service Booking (Widget)"},
    {id: 160, name: "Vehicle Sales Enquiry"},
    {id: 161, name: "Dealer Sign Up"},
    {id: 162, name: "Advertising Enquiry"},
    {id: 163, name: "Vehicle Enquiry"},
    {id: 164, name: "NCT Enquiry"},
    {id: 165, name: "Service & NCT Enquiry"},
    {id: 166, name: "Book a Service"},
    {id: 167, name: "Complaint Enquiry"},
    {id: 168, name: "General Feedback Enquiry"},
    {id: 170, name: "Your Drive Your Way Enquiry"},
    {id: 171, name: "XT5 Test Drive Booking Enquiry"},
    {id: 172, name: "CT6 Test Drive Booking Enquiry"},
    {id: 173, name: "Escalade Test Drive Booking Enquiry"},
    {id: 174, name: "Finance Calculator Enquiry"},
    {id: 175, name: "Online Payment (Widget)"},
    {id: 176, name: "Reserve Online Enquiry"},
    {id: 177, name: "Subject Access Request"},
    {id: 178, name: "Data Portability Request"},
    {id: 179, name: "Data Erasure Request"},
    {id: 180, name: "Data Rectification Request"},
    {id: 181, name: "Update Marketing Preferences Request"},
    {id: 182, name: "Online Payment (OVS Widget)"},
    {id: 183, name: "Offers Enquiry"},
    {id: 184, name: "Corporate Enquiry"},
    {id: 185, name: "Student Enquiry"},
    {id: 186, name: "Central Stock Used Vehicle General Enquiry"},
    {id: 187, name: "Central Stock Used Vehicle Valuation Enquiry"},
    {id: 188, name: "Central Stock Used Vehicle Test Drive Enquiry"},
    {id: 189, name: "Gubagoo Chat Enquiry"},
    {id: 190, name: "Parts & Accessories Order"},
    {id: 999, name: "Used Vehicle Online Deposit"}
];

export const em2EnquiryTypeOptions: SelectOption<number>[] = em2EnquiryTypes.map(type => ({
    label: `${type.name} (${type.id})`,
    value: type.id
}));

export interface Em2EnquiryTypeMappingEvent {
    eventType: Em2EnquiryTypeMappingDTOEventTypeEnum;
    vehicle?: Em2EnquiryVehicle;
    label: string;
    defaultEnquiryType: string;
}

export const em2EnquiryTypeMappingEvents: Em2EnquiryTypeMappingEvent[] = [
    {eventType: EventType.RequestedCallback, label: "Requested Callback", defaultEnquiryType: "Callback Request (56)"},
    {eventType: EventType.BookedCallBack, label: "Booked Callback", defaultEnquiryType: "Callback Request (56)"},
    {eventType: EventType.RequestedServiceCallback, label: "Requested Service Callback", defaultEnquiryType: "Service Enquiry (18)"},
    {eventType: EventType.BookedServiceCallBack, label: "Booked Service Callback", defaultEnquiryType: "Service Enquiry (18)"},
    {eventType: EventType.RequestedTestDrive, vehicle: Em2EnquiryVehicle.New, label: "Requested Test Drive · New Vehicle", defaultEnquiryType: "New Vehicle Test Drive Enquiry (43)"},
    {eventType: EventType.RequestedTestDrive, vehicle: Em2EnquiryVehicle.Used, label: "Requested Test Drive · Used Vehicle", defaultEnquiryType: "Used Vehicle Test Drive Enquiry (30)"},
    {eventType: EventType.BookedTestDrive, vehicle: Em2EnquiryVehicle.New, label: "Booked Test Drive · New Vehicle", defaultEnquiryType: "New Vehicle Test Drive Enquiry (43)"},
    {eventType: EventType.BookedTestDrive, vehicle: Em2EnquiryVehicle.Used, label: "Booked Test Drive · Used Vehicle", defaultEnquiryType: "Used Vehicle Test Drive Enquiry (30)"},
    {eventType: EventType.ReturnedFinanceApplication, label: "Returned Finance Application", defaultEnquiryType: "Finance Enquiry (23)"},
    {eventType: EventType.ReturnedVehicleValuation, label: "Returned Vehicle Valuation", defaultEnquiryType: "Vehicle Valuation Enquiry (39)"},
    {eventType: EventType.RequestedEmailFollowUp, label: "Requested Email Follow-up", defaultEnquiryType: "General Enquiry (40)"},
    {eventType: EventType.BookedEmailFollowUp, label: "Booked Email Follow-up", defaultEnquiryType: "General Enquiry (40)"}
];
